import SectionHeader from "./reusable/SectionHeader";
import WomanPointing from "../assets/images/woman_pointing.webp";
import ButtonPair from "./reusable/ButtonPair";

const Apply = () => {
  return (
    <div className="section_margin rounded">
      <div id="apply" className="w-full sys_bg_white2 pt-10 px-3 lg:px-10">
        <div className="flex items-center justify-center lg:justify-between">
          <div>
            <SectionHeader
              title="Apply"
              caption="Join us to get an assistant or join as an assistant"
              left={true}
            />
            <div className="flex justify-center">
              <ButtonPair />
            </div>
          </div>
          <img
            className="hidden lg:block"
            style={{ width: "414px" }}
            src={WomanPointing}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Apply;
